import gql from 'graphql-tag';

const GET_GROUPS = gql`
	{
		groups {
			id
			name
		}
	}
`;

const CREATE_GROUP = gql`
	mutation($name: String!) {
		group: createGroup(name: $name) {
			id
			name
		}
	}
`;

const UPDATE_GROUP = gql`
	mutation($id: ID!, $name: String) {
		group: updateGroup(id: $id, name: $name) {
			id
			name
		}
	}
`;

const DELETE_GROUP = gql`
	mutation($id: String!) {
		deleteGroup(id: $id)
	}
`;

export {GET_GROUPS, CREATE_GROUP, UPDATE_GROUP, DELETE_GROUP};



// WEBPACK FOOTER //
// ./src/groupsList/queries.js